import React from "react";
const ItemLink = ({ child, resetStates, className, }) => {
    return (<a className={className} href={child.url} onClick={() => {
            if (child === null || child === void 0 ? void 0 : child.onClick)
                child.onClick();
            resetStates();
        }}>
      {child.icon ? (<img alt={child.name} src={child.icon} width={20} height={20} loading="lazy"/>) : null}
      {child.name}
    </a>);
};
export default ItemLink;
